export class ObjectUtils {

  static isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
  }

  static mergeDeep(target, ...sources): Object {
    if (!sources.length) {
      return target;
    }
    const source = sources.shift();

    if (ObjectUtils.isObject(target) && ObjectUtils.isObject(source)) {
      for (const key in source) {
        if (this.isObject(source[key])) {
          if (!target[key]) {
            Object.assign(target, {[key]: {}});
          }
          ObjectUtils.mergeDeep(target[key], source[key]);
        } else {
          Object.assign(target, {[key]: source[key]});
        }
      }
    }

    return ObjectUtils.mergeDeep(target, ...sources);
  }

}

